import api from "../../infra/api";

class SolicitacaoVistoria {
    async Listar (codigoResp, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === "" 
                ? `/api/v1/SolicitacaoVistoria?page=1&start=0&limit=999&fields=["Id","Situacao","CodigoSolicitacaoAcesso","SolicitacaoDeAcesso.CodigoUC","Protocolo","DataCadastro","PrazoAnalise","SituacaoAgendamento","SolicitacaoDeAcesso.SituacaoObra","Observacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":false}]` 
                : `/api/v1/SolicitacaoVistoria?page=1&start=0&limit=999&fields=["Id","Situacao","CodigoSolicitacaoAcesso","SolicitacaoDeAcesso.CodigoUC","Protocolo","DataCadastro","PrazoAnalise","SituacaoAgendamento","SolicitacaoDeAcesso.SituacaoObra","Observacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true}, {"property":"Observacao","operator":"containsall","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async ListarCFiltros(codigoResp, pesquisaGeral) {
        let url = `/api/v1/SolicitacaoVistoria?page=1&start=0&limit=999&includes=["SolicitacaoDeAcesso"]&fields=["Id","Situacao","CodigoSolicitacaoAcesso","SolicitacaoDeAcesso.CodigoUC","Protocolo","DataCadastro","PrazoAnalise","SituacaoAgendamento","SolicitacaoDeAcesso.SituacaoObra","SolicitacaoDeAcesso.Nome","Observacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`;
        
        if (pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);
            url += `,{"property":"Observacao","operator":"containsall","value":"${pesquisaGeral}"},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"SolicitacaoDeAcesso.CodigoUC","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Id","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${pesquisaGeral}","and":false}]`;
        } 

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCfeSituacaoOuDatas(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
        let url = filter.trim() === "" ? 
                    `/api/v1/SolicitacaoVistoria?page=1&start=0&limit=999&includes=["SolicitacaoDeAcesso"]&fields=["Id","Situacao","CodigoSolicitacaoAcesso","SolicitacaoDeAcesso.CodigoUC","Protocolo","DataCadastro","PrazoAnalise","SituacaoAgendamento","SolicitacaoDeAcesso.SituacaoObra","SolicitacaoDeAcesso.Nome","Observacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]` :
                    `/api/v1/SolicitacaoVistoria?page=1&start=0&limit=999&includes=["SolicitacaoDeAcesso"]&fields=["Id","Situacao","CodigoSolicitacaoAcesso","SolicitacaoDeAcesso.CodigoUC","Protocolo","DataCadastro","PrazoAnalise","SituacaoAgendamento","SolicitacaoDeAcesso.SituacaoObra","SolicitacaoDeAcesso.Nome","Observacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=${filter}`

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral.trim() !== "";
        
        if(temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = "," + filtroSituacaoDatas.slice(1);

            return `[{"property":"Id","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"SolicitacaoDeAcesso.CodigoUC","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao);
        let campoParaFiltrarData = (tipoDataFiltro === "data-cadastro") ? "DataCadastro" : "DataEnvioSolicitacao";
        
        if(temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacaoAcesso}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } else if(!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacaoAcesso}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } else {
            return `[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacaoAcesso}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    async listarParaVistoria (codigoResp, filtro)  {
        const response = await api({
            method: "GET",
            url: filtro.trim() === "" 
                ? `/api/v1/SolicitacaoVistoria/${codigoResp}/ListarSolicitacoesDeAcessoParaConexao?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC","TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento"]&sort=[{"property":"Id","direction":"DESC"}]` 
                : `/api/v1/SolicitacaoVistoria/${codigoResp}/ListarSolicitacoesDeAcessoParaConexao?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC","TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"Nome","operator":"containsall","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async Inserir (dto) {
        const response = await api({
            method: "POST",
            url: "/api/v1/SolicitacaoVistoria",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarParaEditar(codigoSolic) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoVistoria/${codigoSolic}/RecuperarParaEditar`,
        });

        return response.data;
    }

    async Editar (dto) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/SolicitacaoVistoria/${dto.Id}`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async InserirDocumentoNaSolicitacao(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/SolicitacaoVistoria/AdicionarAnexoNaSolicitacaoVistoria",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RecuperarAgendamento(codigoSolicitacaoVistoria) {
        const response = await api({
            method: "GET",
            url: "api/v1/SolicitacaoVistoriaAgendamento/RecuperarAgendamento/" + codigoSolicitacaoVistoria
        });

        return response.data;
    }

    async RealizarDownloadDocumento (codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoVistoria/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async ArquivarSolicitacaoVistoria(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoVistoria/ArquivarSolicitacaoVistoria",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RemoverDocumento(codigoDocumento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/SolicitacaoVistoria/RemoverAnexoDocs/${codigoDocumento}`,
        });

        return response.data;
    }
}

export default new SolicitacaoVistoria;